import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import SessionsDropDown from "../Shared/SessionsDropDown";
import WingsDropDown from "../Shared/WingsDropDown";
import ClassesDropDown from "../Shared/ClassesDropDown";
import SectionDropDown from "../Shared/SectionDropDown";
import MonthsDropDown from "../Shared/MonthsDropDown";
import YearsDropDown from "../Shared/YearsDropDown";
import StudentStatusDropDown from "../Shared/StudentStatusDropDown";
import FeeSystemMenu from "./FeeSystemMenu";
import { toast, ToastContainer } from "react-toastify";
import { NavLink } from "react-router-dom";
import moment from "moment";
import Pagination from "../General/Pagination";
import { Form } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

/**
 * Active students who have no voucher (challan) for the selected month/year
 * (e.g. after a voucher was deleted). Same filters as Print Vouchers.
 */
function StudentsMissingVoucher() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [validated, setValidated] = useState(false);

  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [totalRecords, setTotalRecords] = useState(0);

  const [SessionId, setSessionId] = useState(localStorage.getItem("DefaultSession") || "");
  const [NewWingId, setNewWingId] = useState(0);
  const [NewClassId, setNewClassId] = useState(0);
  const [SectionID, setSectionID] = useState(0);
  const [SelectedMonth, setSelectedMonth] = useState(moment().format("M"));
  const [SelectedYear, setSelectedYear] = useState(moment().format("YYYY"));
  const [Keywords, setKeywords] = useState("");
  /** 0 = all (same as SearchStudents); when set, API filters by status and may include inactive students for that status. */
  const [statusTypeId, setStatusTypeId] = useState(0);

  const [reportMonth, setReportMonth] = useState(null);
  const [reportYear, setReportYear] = useState(null);
  /** Increment on each Search so we refetch even when pageNo stays 1; 0 = never searched. */
  const [searchTrigger, setSearchTrigger] = useState(0);

  const fetchData = () => {
    const m = parseInt(SelectedMonth, 10);
    const y = parseInt(SelectedYear, 10);
    if (!m || m < 1 || m > 12 || !y) {
      toast.error("Please select month and year.", { position: toast.POSITION.TOP_RIGHT });
      return;
    }

    setLoading(true);
    const data = {
      AccessKey,
      UserID,
      MemberType,
      pageNo,
      pageSize,
      SessionID: SessionId ? parseInt(SessionId, 10) : 0,
      Wing_Id: parseInt(NewWingId, 10) || 0,
      Class_Id: parseInt(NewClassId, 10) || 0,
      Section_Id: parseInt(SectionID, 10) || 0,
      BusRouteID: 0,
      SelectedMonth: m,
      FYear: y,
      Keywords: Keywords || undefined,
      Status_Type_Id: parseInt(statusTypeId, 10) || 0,
    };

    axios({
      method: "post",
      url: config.base_url + "MonthlyTask/GetStudentsMissingMonthlyVoucher",
      headers: { "Content-Type": "application/json" },
      data,
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          setList(response.data.ListofRecords || []);
          setTotalRecords(response.data.totalRecords || 0);
          setReportMonth(response.data.SelectedMonth ?? m);
          setReportYear(response.data.FYear ?? y);
        } else {
          setList([]);
          setTotalRecords(0);
          toast.error(response.data.status_message || "Could not load report.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Network error.", { position: toast.POSITION.TOP_RIGHT });
      });
  };

  useEffect(() => {
    document.title = "Students Missing Voucher";
  }, []);

  useEffect(() => {
    if (searchTrigger === 0) return;
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNo, pageSize, searchTrigger]);

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }
    const m = parseInt(SelectedMonth, 10);
    const y = parseInt(SelectedYear, 10);
    if (!m || m < 1 || m > 12 || !y) {
      toast.error("Please select month and year.", { position: toast.POSITION.TOP_RIGHT });
      setValidated(true);
      return;
    }
    setPageNo(1);
    setSearchTrigger((t) => t + 1);
    setValidated(true);
  };

  const handlePageChange = (page) => {
    setPageNo(page);
  };

  /** Same tag row as SearchStudents / AdvanceSearch: concession, transport, student status. */
  const renderTags = (row) => {
    const routeId = Number(row.Current_Route_Id) || 0;
    const st = row.Status_Type_Id != null ? Number(row.Status_Type_Id) : 1;
    const statusTooltip =
      st === 1
        ? "Normal Status"
        : st === 2
          ? "Stucked Off"
          : st === 3
            ? "Left"
            : st === 4
              ? "Study Complete"
              : st === 5
                ? "SLC"
                : "Freezed";
    return (
      <div className="status">
        {row.HasConcession === true && (
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={<Tooltip>Concession Applied</Tooltip>}
          >
            <span className="green">
              <i className="ri-percent-fill"></i>
            </span>
          </OverlayTrigger>
        )}
        {routeId > 0 && (
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={<Tooltip>Transport</Tooltip>}
          >
            <span className="red">
              <i className="ri-bus-2-fill"></i>
            </span>
          </OverlayTrigger>
        )}
        <OverlayTrigger
          placement="top"
          delay={{ show: 250, hide: 400 }}
          overlay={<Tooltip>{statusTooltip}</Tooltip>}
        >
          <span className="blue">
            {st === 1 ? (
              <i className="ri-emotion-normal-line"></i>
            ) : st === 2 ? (
              <i className="ri-emotion-unhappy-line"></i>
            ) : st === 3 ? (
              <i className="ri-run-line"></i>
            ) : st === 4 ? (
              <i className="ri-thumb-up-line"></i>
            ) : st === 5 ? (
              <i className="ri-article-line"></i>
            ) : (
              <i className="ri-snowflake-line"></i>
            )}
          </span>
        </OverlayTrigger>
      </div>
    );
  };

  return (
    <>
      <FeeSystemMenu />
      <ToastContainer />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-8">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <NavLink to="/Dashboard">Dashboard</NavLink>
                  </li>
                  <li className="breadcrumb-item">
                    <NavLink to="/FeeSystem/FeeSystemDashboard">Fee System</NavLink>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Missing Voucher Report
                  </li>
                </ol>
              </nav>
              <div className="page-title">Students Missing Monthly Voucher</div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <div className="card mb-3">
            <div className="card-body">
              <p className="text-muted small mb-3">
                Lists students who have <strong>no</strong> non-deleted voucher in <strong>tblChalanHead</strong> for the
                selected month/year (e.g. voucher was deleted or never generated). With <strong>Student Status</strong>{" "}
                set to <strong>All</strong>, only <strong>active</strong> students are included; with a specific status,
                results match that status (same idea as Search Students). Students who joined <strong>after</strong> the
                end of that month are excluded.
              </p>
              <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <div className="row g-3 align-items-end">
                  <div className="col-md-3">
                    <label className="form-label">Session</label>
                    <select
                      className="form-select"
                      value={SessionId}
                      onChange={(e) => {
                        setSessionId(e.target.value);
                        setNewWingId(0);
                        setNewClassId(0);
                        setSectionID(0);
                      }}
                    >
                      <option value="">All sessions</option>
                      <SessionsDropDown selectedSession={SessionId} />
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Wing</label>
                    <select
                      className="form-select"
                      value={NewWingId}
                      onChange={(e) => {
                        setNewWingId(e.target.value);
                        setNewClassId(0);
                        setSectionID(0);
                      }}
                    >
                      <option value="0">All wings</option>
                      <WingsDropDown />
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Class</label>
                    <select
                      className="form-select"
                      value={NewClassId}
                      onChange={(e) => {
                        setNewClassId(e.target.value);
                        setSectionID(0);
                      }}
                    >
                      <option value="0">All classes</option>
                      {SessionId && NewWingId != 0 && (
                        <ClassesDropDown SessionID={SessionId} WingID={NewWingId} />
                      )}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Section</label>
                    <select
                      className="form-select"
                      value={SectionID}
                      onChange={(e) => setSectionID(e.target.value)}
                    >
                      <option value="0">All sections</option>
                      {NewClassId !== 0 && <SectionDropDown ClassID={NewClassId} />}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Student Status</label>
                    <select
                      className="form-select"
                      value={statusTypeId}
                      onChange={(e) => setStatusTypeId(parseInt(e.target.value, 10) || 0)}
                    >
                      <option value="0">---All---</option>
                      <StudentStatusDropDown />
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Month *</label>
                    <select
                      className="form-select"
                      required
                      value={SelectedMonth}
                      onChange={(e) => setSelectedMonth(e.target.value)}
                    >
                      <MonthsDropDown />
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Year *</label>
                    <select
                      className="form-select"
                      required
                      value={SelectedYear}
                      onChange={(e) => setSelectedYear(e.target.value)}
                    >
                      <YearsDropDown />
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Keywords</label>
                    <input
                      type="text"
                      className="form-control"
                      value={Keywords}
                      onChange={(e) => setKeywords(e.target.value)}
                      placeholder="Name, reg. no, father"
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Page size</label>
                    <select
                      className="form-select"
                      value={pageSize}
                      onChange={(e) => {
                        setPageNo(1);
                        setPageSize(parseInt(e.target.value, 10));
                      }}
                    >
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>
                  </div>
                  <div className="col-md-12">
                    <button type="submit" className="button button-primary" disabled={loading}>
                      {loading ? <Spinner animation="border" size="sm" className="me-2" /> : null}
                      Search
                    </button>
                  </div>
                </div>
              </Form>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              {reportMonth != null && reportYear != null && (
                <p className="text-muted mb-2">
                  Month: <strong>{reportMonth}</strong> / Year: <strong>{reportYear}</strong> — Total:{" "}
                  <strong>{totalRecords}</strong>
                </p>
              )}
              <div className="table-responsive">
                <table className="table table-theme table-hover">
                  <thead>
                    <tr>
                      <th>Reg No</th>
                      <th>Student</th>
                      <th>Father</th>
                      <th>Wing</th>
                      <th>Class</th>
                      <th>Section</th>
                      <th>Tags</th>
                      <th>Date of Joining</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="9" className="text-center py-4">
                          <Spinner animation="border" />
                        </td>
                      </tr>
                    ) : list.length === 0 ? (
                      <tr>
                        <td colSpan="9" className="text-center text-muted py-4">
                          No students found without a voucher for the selected filters.
                        </td>
                      </tr>
                    ) : (
                      list.map((row, idx) => (
                        <tr key={row.Student_ID || idx}>
                          <td>{row.Registration_No}</td>
                          <td>{row.Student_Name}</td>
                          <td>{row.Father_Name}</td>
                          <td>{row.Wing_Name}</td>
                          <td>{row.Class_Name}</td>
                          <td>{row.Section_Name}</td>
                          <td>{renderTags(row)}</td>
                          <td>
                            {row.Date_Of_Joining
                              ? moment(row.Date_Of_Joining).format("DD/MM/YYYY")
                              : ""}
                          </td>
                          <td>
                            <NavLink
                              className="button button-sm button-primary"
                              to={`/FeeSystem/GenerateChallan?Student_ID=${row.Student_ID}&Month=${reportMonth || SelectedMonth}&Year=${reportYear || SelectedYear}`}
                            >
                              Generate voucher
                            </NavLink>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
              {totalRecords > pageSize && (
                <Pagination
                  pageNo={pageNo}
                  totalRecords={totalRecords}
                  pageSize={pageSize}
                  onPageChange={handlePageChange}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default StudentsMissingVoucher;
